import { Category } from '../api/models';

export const asServicePriceKey = (category: Category | string): string => {
  switch (category) {
    case Category.SEAT:
      return 'seats';
    case Category.MEAL:
      return 'meals';
    case Category.WIFI:
      return 'wifi';
    case Category.LOUNGE:
      return 'lounge';
    case Category.BAGGAGE:
      return 'baggage';
    case Category.COVER:
      return 'cover';
    default:
      return '';
  }
};

export const asCartId = (category: Category | string): string => {
  switch (category) {
    case Category.MEAL:
      return 'meals';
    case Category.SEAT:
      return 'seats';
    default:
      return category;
  }
};

export enum AdditionalCategories {
  TICKETS = 'tickets',
  TIER = 'tier',
}

const categoryIcons = {
  [Category.SEAT]: 'seat-or-economy',
  [Category.BAGGAGE]: 'checked-in-baggage',
  [Category.CABIN_BAGGAGE]: 'carry-on-bag',
  [Category.MEAL]: 'food',
  [Category.WIFI]: 'wifi',
  [Category.LOUNGE]: 'lounge',
  [Category.COVER]: 'insurance',
  [Category.PET]: 'pet',
  [Category.SPORT]: 'bike',
  [Category.SPECIAL]: 'extra-check-in-baggage',
  [Category.FIREARM]: 'alert',
  [Category.MEDIC]: 'medical-assistance',
  [Category.SPECIAL_NEED]: 'person-special-assist',
  [Category.CHILD]: 'children',
  [Category.OTHER]: 'info',
  [AdditionalCategories.TIER]: 'finnair-plus',
  [AdditionalCategories.TICKETS]: 'flight-status',
};

export const getIconForServiceCategory = (category: Category | string): string =>
  categoryIcons[category] ?? categoryIcons.other;
